import React, { Component } from "react";
import {
  Row,
  Col,
  InputGroup,
  Button,
  FormControl,
  Popover,
  OverlayTrigger,
  Table,
} from "react-bootstrap";
import "../asserts/css/style.css";
import DatePicker from "react-datepicker";
import * as publicUtils from "./utils/publicUtils.js";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ErrorsMessageToast from "./errorsMessageToast";
import store from "./redux/store";
axios.defaults.withCredentials = true;

class customerSalesList extends React.Component {
  state = {
    perCal: [],
    totalHidden: "",
  };
  constructor(props) {
    super(props);
    this.state = this.initialState; //初期化
    this.options = {
      sizePerPage: 12,
      pageStartIndex: 1,
      paginationSize: 3,
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      hideSizePerPage: true,
      alwaysShowAllBtns: true,
      paginationShowsTotal: this.renderShowsTotal,
    };
  }
  initialState = {
    customerSalesListYearAndMonth: new Date(),
    serverIP: store.getState().dropDown[store.getState().dropDown.length - 1],
    customerNo: "",
    customerInfo: [
      { code: "", name: "" },
      ...store.getState().dropDown[73].slice(1),
    ],
    selectedCustomerNos: [],
    selectedDetailEmployees: {},
    activeDetailCustomerNo: null,
    totalpercent: "",
    grossProfitPercent: "",
    unitPTotal: "",
    totalSales: "",
    totalgrossProfit: "",
    perCal: [],
    CustomerSaleslListInfoList: [],
    totalGrossProfitAdd: 0,
    countPeo: 0,
  };

  getAuthorityCode = async () => {
    axios
      .post(this.state.serverIP + "sendLettersConfirm/getLoginUserInfo")
      .then((result) => {
        this.setState({
          authorityCode: result.data[0].authorityCode,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  componentDidMount() {
    this.getAuthorityCode();
    const location = this.props.location;
    const saved = location && location.state && location.state.sendValue;
    if (saved) {
      this.setState({
        customerSalesListYearAndMonth: saved.customerSalesListYearAndMonth
          ? new Date(saved.customerSalesListYearAndMonth) : "",
        customerNo: saved.customerNo || "",
      }, this.searchCustomer);
    } else {
      this.searchCustomer();
    }
  }

  renderShowsTotal = () => {
    return (
      <p
        hidden={!this.state.CustomerSaleslListInfoList.length > 0}
        style={{ color: "dark", float: "left" }}
      >
        稼働人数：{this.state.countPeo}
      </p>
    );
  };

  customerSalesListYearAndMonth = (date) => {
    if (date !== null) {
      this.setState(
        {
          customerSalesListYearAndMonth: date,
        },
        () => this.searchCustomer()
      );
    } else {
      this.setState({
        customerSalesListYearAndMonth: "",
      }, this.searchCustomer);
    }
  };

  customerChange = (event, customer) => {
    this.setState({ customerNo: customer ? customer.code : "" }, this.searchCustomer);
  };

  resetSearchResult = () => {
    this.setState({
      CustomerSaleslListInfoList: [],
      selectedCustomerNos: [],
      selectedDetailEmployees: {},
      activeDetailCustomerNo: null,
      countPeo: 0,
      unitPTotal: "",
      totalSales: "",
      totalgrossProfit: "",
      totalpercent: "",
      grossProfitPercent: "",
    });
    if (this.refs.CustomerSaleslListInfoListTable) {
      this.refs.CustomerSaleslListInfoListTable.setState({ selectedRowKeys: [], currPage: 1 });
    }
  };

  searchCustomer = () => {
    const requestId = (this.searchRequestId || 0) + 1;
    this.searchRequestId = requestId;
    this.resetSearchResult();
    if (!this.state.customerSalesListYearAndMonth) return;
    const customerSalesListInfo = {
      yearAndMonth: publicUtils.formateDate(
        this.state.customerSalesListYearAndMonth,
        false
      ),
      customerNo: this.state.customerNo,
    };

    axios
      .post(
        this.state.serverIP + "customerSalesList/searchCustomerSalesList",
        customerSalesListInfo
      )
      .then((response) => {
        if (requestId !== this.searchRequestId) return;
        const message = response.data.errorsMessage || response.data.noData;
        if (message) {
          this.setState({ errorsMessageShow: true, errorsMessageValue: message });
          return;
        }
        const rows = response.data.data || [];
        const countPeo = rows.reduce((total, row) => total + Number(row.countPeo), 0);
        const summary = rows[0];
        this.setState({
          errorsMessageShow: false,
          CustomerSaleslListInfoList: rows,
          countPeo,
          unitPTotal: summary && countPeo
            ? publicUtils.addComma((summary.unitPTotal / countPeo).toFixed(0), false)
            : "",
          totalSales: summary ? publicUtils.addComma(summary.totalSales, false) : "",
          totalgrossProfit: summary ? publicUtils.addComma(summary.totalgrossProfit, false) : "",
        });
      })
      .catch((error) => {
        if (requestId === this.searchRequestId) console.error("Error - " + error);
      });
  };

  averUnitPriceFormat(cell, row) {
    if (
      row.averUnitPrice === null ||
      row.averUnitPrice === "0" ||
      row.averUnitPrice === NaN
    ) {
      return;
    } else {
      let averageUnitP;
      let formatTotalUnitPrice = row.averUnitPrice.split(".")[1];
      if (formatTotalUnitPrice !== "0") {
        averageUnitP = row.averUnitPrice;
      } else {
        averageUnitP = row.averUnitPrice.split(".")[0];
      }
      return publicUtils.addComma(averageUnitP, false);
    }
  }

  totalUnitPriceFormat(cell, row) {
    if (row.totalUnitPrice === null || row.totalUnitPrice === "0") {
      return;
    } else {
      let formatTotalUnitPrice = row.totalUnitPrice;
      return publicUtils.addComma(formatTotalUnitPrice, false);
    }
  }

  costChange = (cell, row) => {
    if (!(row.employeeNo || "").startsWith("BP")) return "";
    if (cell === "0") return "";
    if (Number(row.cost) > Number(row.unitPrice))
      return <div style={{ color: "red" }}>{cell}</div>;
    return cell;
  };

  workingStartMonthFormat = (cell) => {
    if (!cell || !/^\d{6}(\d{2})?$/.test(cell)) return "";
    const startYear = Number(cell.substring(0, 4));
    const startMonth = Number(cell.substring(4, 6));
    if (startMonth < 1 || startMonth > 12) return "";
    const yearAndMonth = `${cell.substring(0, 4)}/${cell.substring(4, 6)}`;
    const searchMonth = this.state.customerSalesListYearAndMonth;
    if (!searchMonth || Number.isNaN(searchMonth.getTime())) return yearAndMonth;
    const months = (searchMonth.getFullYear() - startYear) * 12
      + searchMonth.getMonth() + 1 - startMonth + 1;
    if (months < 1) return yearAndMonth;
    return (
      <span>
        {yearAndMonth}（<span style={{ color: "red" }}>{months}</span>ヶ月）
      </span>
    );
  };

  handleDetailSelect = (customerNo, employee, isSelected) => {
    this.setState((state) => ({
      selectedDetailEmployees: {
        ...state.selectedDetailEmployees,
        [customerNo]: isSelected ? employee.employeeNo : "",
      },
    }));
  };

  openEmployeeInfo = (customerNo, action) => {
    const employeeNo = this.state.selectedDetailEmployees[customerNo];
    if (!employeeNo) return;
    const sendValue = {
      customerSalesListYearAndMonth: this.state.customerSalesListYearAndMonth,
      customerNo: this.state.customerNo,
    };
    const state = { backPage: "customerSalesList", sendValue };
    if (action === "personal") {
      this.props.history.push({
        pathname: "/subMenuManager/employeeUpdateNew",
        state: { ...state, actionType: "update", id: employeeNo },
      });
    } else if (action === "site") {
      this.props.history.push({
        pathname: "/subMenuManager/siteInfo",
        state: { ...state, employeeNo },
      });
    }
  };

  toggleEmployeeDetail = (customerNo, show) => {
    this.setState((state) => {
      if (show) {
        return { activeDetailCustomerNo: customerNo, selectedDetailEmployees: {} };
      }
      if (state.activeDetailCustomerNo !== customerNo) return null;
      return { activeDetailCustomerNo: null, selectedDetailEmployees: {} };
    });
  };

  renderEmployeeDetailTable = (row, employees, offset = 0) => {
    const selectedEmployeeNo = this.state.selectedDetailEmployees[row.customerNo];
    const options = {
      noDataText: (
        <i className="" style={{ fontSize: "20px" }}>
          データなし
        </i>
      ),
      expandRowBgColor: "rgb(165, 165, 165)",
      hideSizePerPage: true, //> You can hide the dropdown for sizePerPage
      expandRowBgColor: "rgb(165, 165, 165)",
    };
    const selectRow = {
      mode: "radio",
      bgColor: "pink",
      hideSelectColumn: true,
      clickToSelect: true,
      clickToExpand: true,
      selected: employees.some((employee) => employee.employeeNo === selectedEmployeeNo)
        ? [selectedEmployeeNo] : [],
      onSelect: (employee, isSelected) => this.handleDetailSelect(row.customerNo, employee, isSelected),
    };
    return (
      <BootstrapTable
        pagination={false}
        options={options}
        data={employees.map((employee, index) => ({
          ...employee,
          detailRowNo: offset + index + 1,
        }))}
        selectRow={selectRow}
        headerStyle={{ background: "#5599FF" }}
        striped
        hover
        condensed
      >
        <TableHeaderColumn
          dataField="detailRowNo"
          tdStyle={{ padding: ".45em" }}
          width="8%"
        >
          番号
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="employeeName"
          tdStyle={{ padding: ".45em" }}
          width="22%"
        >
          氏名
        </TableHeaderColumn>
        <TableHeaderColumn isKey dataField="employeeNo" hidden>
          社員番号
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="recentAdmissionStartDate"
          dataFormat={this.workingStartMonthFormat}
          tdStyle={{ padding: ".45em" }}
          width="25%"
        >
          稼働開始年月
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="siteRoleName"
          tdStyle={{ padding: ".45em" }}
          width="8%"
        >
          役割
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="stationName"
          tdStyle={{ padding: ".45em" }}
          width="13%"
        >
          現場先
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="unitPrice"
          tdStyle={{ padding: ".45em" }}
          width="12%"
        >
          単価(万)
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="cost"
          dataFormat={this.costChange}
          tdStyle={{ padding: ".45em" }}
          width="12%"
        >
          費用(万)
        </TableHeaderColumn>
      </BootstrapTable>
    );
  };

  empDetailCheck = (cell, row) => {
    let returnItem = cell;
    const selectedEmployeeNo = this.state.selectedDetailEmployees[row.customerNo];
    returnItem = (
      <OverlayTrigger
        trigger="click"
        placement={"left"}
        rootClose
        show={this.state.activeDetailCustomerNo === row.customerNo}
        onToggle={(show) => this.toggleEmployeeDetail(row.customerNo, show)}
        overlay={
          <Popover className="popoverC customer-sales-detail-popover">
            <Popover.Content style={{ overflowX: "auto", overflowY: "auto", maxHeight: "calc(100vh - 80px)" }}>
              <div style={{ minWidth: "770px" }} onClick={(event) => event.stopPropagation()}>
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    variant="info"
                    size="sm"
                    className="mr-2"
                    disabled={!selectedEmployeeNo}
                    onClick={() => this.openEmployeeInfo(row.customerNo, "personal")}
                  >
                    個人情報
                  </Button>
                  <Button
                    variant="info"
                    size="sm"
                    disabled={!selectedEmployeeNo}
                    onClick={() => this.openEmployeeInfo(row.customerNo, "site")}
                  >
                    現場情報
                  </Button>
                </div>
                <div className="mb-2">当月稼働</div>
                {this.renderEmployeeDetailTable(row, row.empDetail || [])}
                {row.nextMonthEmpDetail && row.nextMonthEmpDetail.length > 0 && (
                  <React.Fragment>
                    <hr style={{ borderTop: "4px solid #495057", margin: "12px 0" }} />
                    <div className="mb-2">来月入場予定</div>
                    {this.renderEmployeeDetailTable(
                      row, row.nextMonthEmpDetail, (row.empDetail || []).length
                    )}
                  </React.Fragment>
                )}
              </div>
            </Popover.Content>
          </Popover>
        }
      >
        <Button variant="warning" size="sm">
          要員確認
        </Button>
      </OverlayTrigger>
    );
    return returnItem;
  };

  overTimeFeeAddComma(cell, row) {
    if (row.overTimeFee === null || row.overTimeFee === "0") {
      return;
    } else {
      let formatoverTimeFee = publicUtils.addComma(row.overTimeFee, false);
      return formatoverTimeFee;
    }
  }
  expectFeeAddComma(cell, row) {
    if (row.expectFee === null || row.expectFee === "0") {
      return "";
    } else {
      let formatexpectFee = publicUtils.addComma(row.expectFee, false);
      return <div style={{ color: "red" }}>{formatexpectFee}</div>;
    }
  }

  totalAmountAddComma(cell, row) {
    if (row.totalAmount === null || row.totalAmount === "0") {
      return "";
    } else {
      let formattotalAmount = publicUtils.addComma(row.totalAmount, false);
      return formattotalAmount;
    }
  }

  grossProfitAddComma(cell, row) {
    if (row.grossProfit === null /*||row.grossProfit==="0"*/) {
      return "";
    } else {
      if (row.grossProfit < 0) {
        let formatgrossProfit = publicUtils.addComma(row.grossProfit, false);
        return <div style={{ color: "red" }}>{formatgrossProfit}</div>;
      }
      let formatgrossProfit = publicUtils.addComma(row.grossProfit, false);
      return formatgrossProfit;
    }
  }

  // 鼠标悬停显示全文
  customerNameFormat = (cell) => {
    return <span title={cell}>{cell}</span>;
  };

  handleRowSelect = (row, isSelected) => {
    this.setState((state) => {
      const selectedCustomerNos = state.selectedCustomerNos.filter((no) => no !== row.customerNo);
      if (isSelected) selectedCustomerNos.push(row.customerNo);
      const selectedRows = state.CustomerSaleslListInfoList.filter(
        (item) => selectedCustomerNos.includes(item.customerNo)
      );
      const sales = selectedRows.reduce((total, item) => total +
        Number(item.totalUnitPrice || 0) + Number(item.overTimeFee || 0) + Number(item.expectFee || 0), 0);
      const grossProfit = selectedRows.reduce((total, item) => total + Number(item.grossProfit || 0), 0);
      const summary = state.CustomerSaleslListInfoList[0];
      const percent = (value, total) => total ? (value / total * 100).toFixed(1) + "%" : "0.0%";
      return {
        selectedCustomerNos,
        totalpercent: percent(sales, summary ? Number(summary.totalSales) : 0),
        grossProfitPercent: percent(grossProfit, summary ? Number(summary.totalgrossProfit) : 0),
      };
    });
  };

  render() {
    const { errorsMessageValue } = this.state;
    const selectRow = {
      mode: "checkbox",
      bgColor: "pink",
      hideSelectColumn: true,
      clickToSelect: true,
      clickToExpand: true,
      singleSelect: false,
      onSelect: this.handleRowSelect.bind(this),
    };
    return (
      <div>
        <div
          style={{ display: this.state.errorsMessageShow ? "block" : "none" }}
        >
          <ErrorsMessageToast
            errorsMessageShow={this.state.errorsMessageShow}
            message={errorsMessageValue}
            type={"danger"}
          />
        </div>
        <Row inline="true">
          <Col className="text-center">
            <h2>お客様売上一覧</h2>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <InputGroup size="sm" className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroup-sizing-sm">
                  年月
                </InputGroup.Text>
                <DatePicker
                  selected={this.state.customerSalesListYearAndMonth}
                  onChange={this.customerSalesListYearAndMonth}
                  autoComplete="off"
                  showMonthYearPicker
                  showFullMonthYearPicker
                  showDisabledMonthNavigation
                  className="form-control form-control-sm"
                  id="customerSalesListDatePicker"
                  dateFormat={"yyyy/MM"}
                  name="customerSalesListYearAndMonth"
                  locale="ja"
                />
              </InputGroup.Prepend>
            </InputGroup>
          </Col>
          <Col sm={3}>
            <InputGroup size="sm" className="mb-3 flexWrapNoWrap">
              <InputGroup.Prepend>
                <InputGroup.Text>お客様名</InputGroup.Text>
              </InputGroup.Prepend>
              <Autocomplete
                className="fx1"
                id="customerSalesListCustomer"
                options={this.state.customerInfo}
                getOptionLabel={(option) => option.name || ""}
                renderOption={(option) => option.name || "\u00a0"}
                getOptionSelected={(option, value) => option.code === value.code}
                value={this.state.customerInfo.find((item) => item.code === this.state.customerNo) || null}
                onChange={this.customerChange}
                renderInput={(params) => (
                  <div ref={params.InputProps.ref}>
                    <input
                      {...params.inputProps}
                      placeholder="お客様名"
                      className="auto form-control Autocompletestyle-siteInfoSearch-customerNo w100p"
                    />
                  </div>
                )}
              />
            </InputGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text
                  id="inputGroup-sizing-sm"
                  className="input-group-indiv"
                >
                  全体比率
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl value={this.state.totalpercent} disabled />
            </InputGroup>
          </Col>
          {this.state.authorityCode === '4' ? <Col>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text
                  id="inputGroup-sizing-sm"
                  className="input-group-indiv"
                >
                  粗利比率
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl value={this.state.grossProfitPercent} disabled />
            </InputGroup>
          </Col> : null}


          <Col>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text
                  id="inputGroup-sizing-sm"
                  className="input-group-indiv"
                >
                  平均単価
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl value={this.state.unitPTotal} disabled />
            </InputGroup>
          </Col>

          <Col>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text
                  id="inputGroup-sizing-sm"
                  className="input-group-indiv"
                >
                  売上合計
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl value={this.state.totalSales} disabled />
            </InputGroup>
          </Col>
          {this.state.authorityCode === '4' ? <Col>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text
                  id="inputGroup-sizing-sm"
                  className="input-group-indiv"
                >
                  粗利合計
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl value={this.state.totalgrossProfit} disabled />
            </InputGroup>
          </Col> : null}

        </Row>
        <Col>
          <BootstrapTable
            data={this.state.CustomerSaleslListInfoList}
            ref="CustomerSaleslListInfoListTable"
            pagination={true}
            selectRow={selectRow}
            headerStyle={{ background: "#5599FF" }}
            options={this.options}
            striped
            hover
            condensed
          >
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="rowNo"
              isKey
              width="60"
            >
              番号
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="customerName"
              width="150"
              dataFormat={this.customerNameFormat.bind(this)}
            >
              お客様名
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="totalUnitPrice"
              dataFormat={this.totalUnitPriceFormat}
              width="100"
            >
              単価合計
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="averUnitPrice"
              dataFormat={this.averUnitPriceFormat}
              width="100"
            >
              平均単価
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="lastMonthCountPeo"
              width="120"
            >
              先月稼働人数
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="countPeo"
              width="100"
            >
              稼働人数
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="nextMonthCountPeo"
              width="120"
            >
              来月稼働人数
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="empDetailCheck"
              dataFormat={this.empDetailCheck.bind(this)}
              width="100"
            >
              要員確認
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="totalAmount"
              dataFormat={this.totalAmountAddComma}
              width="110"
            >
              費用
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="grossProfit"
              dataFormat={this.grossProfitAddComma}
              width="100"
            >
              粗利
            </TableHeaderColumn>
          </BootstrapTable>
        </Col>
      </div>
    );
  }
}
export default customerSalesList;
